import React from 'react';
import { ActivityResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface ActivityDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  activity: ActivityResponse | null;
}

export const ActivityDeleteDialog: React.FC<ActivityDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  activity,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="activity"
      itemId={activity?.id || ''}
    />
  );
};
